import React, { useContext } from "react";
import { ContentTraverserContext } from "./../../ricos-context";
import { getAnchor } from "./components/Anchor";
import { nodeViewContainer as NodeViewContainer } from "./rericos/renderers/plugins/nodeViewContainer";
const Fallback = ({ node }) => {
  return false ? /* @__PURE__ */ React.createElement("div", null, `Type ${node.type} is not supported yet (:`) : null;
};
const RicosNodeDecorated = ({
  node,
  index,
  isRoot,
  shouldParagraphApplyTextStyle
}) => {
  const { renderers, nodeViewDecorators } = useContext(ContentTraverserContext);
  const Renderer = renderers[node.type];
  if (!Renderer) {
    console.error(`RicosNodeDedcorated Error: no renderer passed for node type - ${node.type}`);
    return /* @__PURE__ */ React.createElement(Fallback, { node });
  }
  return nodeViewDecorators.apply(
    /* @__PURE__ */ React.createElement(
      Renderer,
      {
        node,
        key: node.id ?? index.toString(),
        RicosNodesRenderer,
        isRoot,
        nodeIndex: index,
        NodeViewContainer,
        shouldParagraphApplyTextStyle
      }
    ),
    node,
    !!isRoot
  );
};
const RicosNodesRenderer = ({
  nodes,
  isRoot,
  shouldParagraphApplyTextStyle,
  addAnchorsPrefix
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, nodes.flatMap((node, index) => {
    return [
      /* @__PURE__ */ React.createElement(
        RicosNodeDecorated,
        {
          isRoot,
          node,
          index,
          key: node.id,
          shouldParagraphApplyTextStyle
        }
      ),
      ...addAnchorsPrefix ? [getAnchor(node, index, addAnchorsPrefix)] : []
    ];
  }));
};
var RicosNodesRenderer_default = RicosNodesRenderer;
export {
  RicosNodesRenderer_default as default
};
//# sourceMappingURL=RicosNodesRenderer.js.map
